import { Form, Input, notification, Radio, Select, Switch, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import ImgCrop from 'antd-img-crop';

import Collapse from '../Collapse';
import { ICON, ICON_POSITION } from './icon';
import { useState, useMemo } from 'react';
import { useEffect } from 'react';
import GlobalService from '../../../../services/Global.service';
import CustomizeBannerService from '../../../../services/CustomizeBanner.service';
import IconCookie from './IconCookie';
import InputColor from '../../../../components/Shared/forms/InputColor';
import { useBannerContext } from '../../context';
import { POSITION_BANNER } from '../../POSITION_BANNER';

const { Option } = Select;

const Style = ({ form, setLogoId }) => {
    const UIContext = useBannerContext();
    const UIProps = useMemo(() => {
        return {
            setLogo: UIContext.setLogo,
        };
    }, [UIContext]);

    const { t } = useTranslation();
    const [fileList, setFileList] = useState([]);
    const [errorColor, setErrorColor] = useState(false);
    const [errorColorFont, setErrorColorFont] = useState(false);
    const [errorDisplay, setErrorDisplay] = useState(false);
    const [errorLogo, setErrorLogo] = useState(false);
    const [errorCookieCompany, setErrorCookieCompany] = useState(false);
    const [showLogo, setShowLogo] = useState(false);
    const [positionList, setPositionList] = useState([]);

    const position = Form.useWatch(['position'], form);
    const positionIcon = Form.useWatch(['positionIcon'], form);
    const useDefaultIcon = Form.useWatch(['useDefaultIcon'], form);
    const rejectedAll = Form.useWatch(['rejectedAll'], form);
    const iconColor = Form.useWatch(['iconColor'], form);
    const iconBackground = Form.useWatch(['iconBackground'], form);

    const iconCookieId = form.getFieldValue(['iconCookieId']);
    const iconOptions = [
        {
            label: t('COOKIE.upload'),
            value: true,
        },
        {
            label: t('COOKIE.default'),
            value: false,
        },


    ];
    useEffect(() => {
        if (iconCookieId) {
            getImage(iconCookieId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iconCookieId]);

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(logoId);
            if (data.resultData?.imageId) {
                UIProps.setLogo(
                    `data:image/png;base64,${data.resultData?.imageId}`
                );
                setFileList([
                    {
                        uid: '-1',
                        name: 'image.png',
                        status: 'done',
                        url: `data:image/png;base64,${data.resultData?.imageId}`,
                    },
                ]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile'),
            });
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller'),
            });
        }

        return isJpgOrPng && isLt2M;
    };

    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);

                reader.onload = () => resolve(reader.result);
            });
        }

        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        beforeUpload,
        className: 'customize_logo mt-2',
        accept: '.png,.jpg,.jpeg',
        fileList,
        onPreview,
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);
            }
        },
        onSuccess: async (res, file) => {
            form?.setFieldsValue({
                iconCookieId: res?.imageId,
            });
            setLogoId(res?.imageId);
            try {
                const { data } = await GlobalService.getImageNoSecure(
                    res?.imageId
                );
                if (data.resultData?.imageId) {
                    UIProps.setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        },
        onError(err) {
            console.log('onError', err);
        },
        onRemove() {
            form?.setFieldsValue({
                iconCookieId: null,
            });
            setLogoId(null);
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');
            try {
                const { data } = await GlobalService.uploadImage(fileList);
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };

    const checkColor = (_, value) => {
        if (value) {
            setErrorColor(false);
            return Promise.resolve();
        }
        setErrorColor(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkColorFont = (_, value) => {
        if (value) {
            setErrorColorFont(false);
            return Promise.resolve();
        }
        setErrorColorFont(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkDisplay = (_, value) => {
        if (value) {
            setErrorDisplay(false);
            return Promise.resolve();
        }
        setErrorDisplay(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const checkLogo = (_, value) => {
        if (showLogo) {
            if (value) {
                setErrorLogo(false);
                return Promise.resolve();
            } else {
                setErrorLogo(false);
                return Promise.reject(new Error(t('errorText.requiredField')));
            }
        }
        if (!showLogo) {
            setErrorLogo(false);
            return Promise.resolve();
        }
        setErrorLogo(false);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    useEffect(() => {
        form.validateFields([['iconCookieId']]);
    }, [showLogo, form]);

    useEffect(() => {
        const defaultLogo = form.getFieldValue('useDefaultIcon');
        const iconCompany =form.getFieldValue('iconCookieId');
        if(!defaultLogo) {
            !iconCompany ? setErrorCookieCompany(true) : setErrorCookieCompany(false)
        } else {
            setErrorCookieCompany(false)
        }
    }, [useDefaultIcon, iconCookieId])

    useEffect(() => {
        form.validateFields([['rejectedAllTh'], ['rejectedAllEn']]);
    }, [rejectedAll, form]);

    useEffect(() => {
        const getBannerPosition = async () => {
            try {
                const { data } =
                    await CustomizeBannerService.getBannerPosition();
                if (data?.resultData) {
                    console.log('data?.resultData ', data?.resultData);
                    setPositionList(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getBannerPosition();
    }, []);

    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize your style')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Collapse
                    error={errorLogo}
                    icon={ICON.EIGHT}
                    title={t('COOKIE.LogoPoweredBy')}
                >
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-xs text-[#65707A]">
                            {t('COOKIE.ShowLogo')}
                        </div>
                        <Form.Item
                            noStyle
                            name={['hiddenLogo']}
                            valuePropName="checked"
                        >
                            <Switch
                                onChange={(checked) => setShowLogo(checked)}
                            />
                        </Form.Item>
                    </div>
                </Collapse>
                <Collapse
                    error={errorColorFont}
                    icon={ICON.SEVEN}
                    title={t('COOKIE.FontStyle')}
                >
                    <Form.Item
                        label={
                            <div className="text-sm">{t('COOKIE.Font')}</div>
                        }
                        name={['fontFamily']}
                        className="pl-2"
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            size="large"
                            style={{ width: '100%' }}
                        >
                            <Option value="Arial">Arial (EN)</Option>
                            <Option value="Georgia">Georgia (EN)</Option>
                            <Option value="Tahoma">Tahoma (EN)</Option>
                            <Option value="Trebuchet">Trebuchet MS (EN)</Option>
                            <Option value="Verdana">Verdana (EN)</Option>
                            <Option value="Prompt">Prompt (TH-EN)</Option>
                            <Option value="Kanit">Kanit (TH-EN)</Option>
                            <Option value="Sarabun">Sarabun (TH-EN)</Option>
                            <Option value="Pridi">Pridit (TH-EN)</Option>
                            <Option value="Noto_sans">
                                Noto Sans Thai (TH-EN)
                            </Option>
                        </Select>
                    </Form.Item>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Heder')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['header', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['header', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Description')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['description', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['description', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.PowerBy')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['powerBy', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['powerBy', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Hyperlink')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['hyperlink', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['hyperlink', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Button')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['button', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['button', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                </Collapse>
                <Collapse
                    error={errorColor}
                    icon={ICON.SIX}
                    title={t('COOKIE.ThemeColor')}
                >
                    <Form.Item
                        label={
                            <div className="font-semibold  text-sm">
                                {t('COOKIE.CardColor')}
                            </div>
                        }
                        name={['backgroundThemeColor']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>

                    <Form.Item
                        label={
                            <div className="font-semibold  text-sm">
                                {t('COOKIE.ButtonColor')}
                            </div>
                        }
                        name={['buttonThemeColor']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                </Collapse>
                <Collapse
                    error={errorDisplay}
                    icon={ICON[1]}
                    title={t('COOKIE.DisplayButton')}
                >
                    <Form.Item
                        label={
                            <div className="font-semibold text-sm">
                                {t('COOKIE.AcceptAllButton')}
                            </div>
                        }
                        name={['acceptAllTh']}
                        rules={[{ validator: checkDisplay }]}
                    >
                        <Input addonBefore="TH" size="large" />
                    </Form.Item>
                    <Form.Item
                        name={['acceptAllEn']}
                        rules={[{ validator: checkDisplay }]}
                    >
                        <Input addonBefore="EN" size="large" />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold text-sm">
                                {t('COOKIE.ChangePreferenesButton')}
                            </div>
                        }
                        name={['changePreferenceTh']}
                        rules={[{ validator: checkDisplay }]}
                    >
                        <Input addonBefore="TH" size="large" />
                    </Form.Item>
                    <Form.Item
                        name={['changePreferenceEn']}
                        rules={[{ validator: checkDisplay }]}
                    >
                        <Input addonBefore="EN" size="large" />
                    </Form.Item>
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-sm font-semibold">
                            {t('COOKIE.RejectedAllButton')}
                        </div>
                        <Form.Item
                            noStyle
                            name={['rejectedAll']}
                            valuePropName="checked"
                        >
                            <Switch />
                        </Form.Item>
                    </div>
                    {rejectedAll && (
                        <>
                            <Form.Item
                                name={['rejectedAllTh']}
                                rules={[{ validator: checkDisplay }]}
                            >
                                <Input addonBefore="TH" size="large" />
                            </Form.Item>
                            <Form.Item
                                name={['rejectedAllEn']}
                                rules={[{ validator: checkDisplay }]}
                            >
                                <Input addonBefore="EN" size="large" />
                            </Form.Item>
                        </>
                    )}
                    <p className="text-[#95A0A8] text-[13px]">
                        {t('COOKIE.RejectedAllDescription')}
                    </p>
                </Collapse>
                <Collapse icon={ICON[2]} title={t('COOKIE.BannerPosition')}>
                    <Form.Item
                        label={
                            <p className="text-sm">
                                {t('COOKIE.ChooseLayout')}
                            </p>
                        }
                        name={['position']}
                        className="text-center"
                    >
                        <Radio.Group className="radio-custom-banner">
                            {positionList?.map((e) => (
                                <>
                                    <Radio value={e.mbannerPositionId}>
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.TOP && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.TOP
                                                        ? ICON_POSITION.TOP_ACTIVE
                                                        : ICON_POSITION.TOP}
                                                </>
                                            )}
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.BOTTOM && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.BOTTOM
                                                        ? ICON_POSITION.BOTTOM_ACTIVE
                                                        : ICON_POSITION.BOTTOM}
                                                </>
                                            )}
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.TOP_CENTER && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.TOP_CENTER
                                                        ? ICON_POSITION.TOP_CENTER_ACTIVE
                                                        : ICON_POSITION.TOP_CENTER}
                                                </>
                                            )}
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.BOTTOM_CENTER && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.BOTTOM_CENTER
                                                        ? ICON_POSITION.BOTTOM_CENTER_ACTIVE
                                                        : ICON_POSITION.BOTTOM_CENTER}
                                                </>
                                            )}
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.BOTTOM_FULL && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.BOTTOM_FULL
                                                        ? ICON_POSITION.BOTTOM_FULL_ACTIVE
                                                        : ICON_POSITION.BOTTOM_FULL}
                                                </>
                                            )}
                                        {e.mbannerPositionId ===
                                            POSITION_BANNER.TOP_FULL && (
                                                <>
                                                    {position ===
                                                        POSITION_BANNER.TOP_FULL
                                                        ? ICON_POSITION.TOP_FULL_ACTIVE
                                                        : ICON_POSITION.TOP_FULL}
                                                </>
                                            )}
                                    </Radio>
                                </>
                            ))}
                            {/* <Radio value="top">
                                {position === 'top'
                                    ? ICON_POSITION.TOP_ACTIVE
                                    : ICON_POSITION.TOP}
                            </Radio>
                            <Radio value="bottom">
                                {position === 'bottom'
                                    ? ICON_POSITION.BOTTOM_ACTIVE
                                    : ICON_POSITION.BOTTOM}
                            </Radio>
                            <Radio value="top-center">
                                {position === 'top-center'
                                    ? ICON_POSITION.TOP_CENTER_ACTIVE
                                    : ICON_POSITION.TOP_CENTER}
                            </Radio>
                            <Radio value="bottom-center">
                                {position === 'bottom-center'
                                    ? ICON_POSITION.BOTTOM_CENTER_ACTIVE
                                    : ICON_POSITION.BOTTOM_CENTER}
                            </Radio>
                            <Radio value="top-fully">
                                {position === 'top-fully'
                                    ? ICON_POSITION.TOP_FULL_ACTIVE
                                    : ICON_POSITION.TOP_FULL}
                            </Radio>
                            <Radio value="bottom-fully">
                                {position === 'bottom-fully'
                                    ? ICON_POSITION.BOTTOM_FULL_ACTIVE
                                    : ICON_POSITION.BOTTOM_FULL}
                            </Radio> */}
                        </Radio.Group>
                    </Form.Item>
                </Collapse>
                <Collapse icon={ICON[3]} title={t('COOKIE.CloseButton')}>
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-sm">{t('COOKIE.CloseButton')}</div>
                        <Form.Item
                            noStyle
                            name={['closeable']}
                            valuePropName="checked"
                        >
                            <Switch
                                onChange={(checked) => setShowLogo(checked)}
                            />
                        </Form.Item>
                    </div>
                </Collapse>
                <Collapse error={errorCookieCompany} icon={ICON[4]} title={t('COOKIE.HowToModifyCookies')}>
                    <div className="flex justify-between items-center mb-2">
                        <div className="text-sm font-semibold">
                            {t('COOKIE.AlwaysDisplay')}
                        </div>
                        <Form.Item
                            noStyle
                            name={['alwaysDisplay']}
                            valuePropName="checked"
                        >
                            <Switch
                                onChange={(checked) => setShowLogo(checked)}
                            />
                        </Form.Item>
                    </div>
                    <p className="text-[#95A0A8] text-[13px]">
                        {t('COOKIE.AlwaysDisplayDescription')}
                    </p>
                    <Form.Item
                        label={
                            <p className="text-sm">
                                {t('COOKIE.ChooseLayout')}
                            </p>
                        }
                        name={['positionIcon']}
                        className="text-center"
                    >
                        <Radio.Group className="radio-custom-banner">
                            <Radio value="bottom-left">
                                {positionIcon === 'bottom-left'
                                    ? ICON_POSITION.BOTTOM_LEFT_ACTIVE
                                    : ICON_POSITION.BOTTOM_LEFT}
                            </Radio>
                            <Radio value="bottom-right">
                                {positionIcon === 'bottom-right'
                                    ? ICON_POSITION.BOTTOM_RIGHT_ACTIVE
                                    : ICON_POSITION.BOTTOM_RIGHT}
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <div style={{ borderTop: '1px solid #F2F2F2' }}>
                        <p className="text-sm font-semibold pt-2 ant-form-item-iconCookieId">
                            {t('COOKIE.ChooseIconCookie')}
                        </p>
                        <div
                            className="flex justify-center items-center pt-2 mb-2"

                        >

                            <Form.Item
                                noStyle
                                name={['useDefaultIcon']}
                            >
                                <Radio.Group className='radio-custom-icon pb-2'  options={iconOptions} size='large' onChange={(checked) => setShowLogo(checked)} value={showLogo} optionType="button" style={{ width: '100%' }} />
                            </Form.Item>

                        </div>
                    </div>

                    {useDefaultIcon ? (
                        <>
                            <div className="mb-2">
                                {t('COOKIE.SelectColorYouWant')}
                            </div>
                            <div className="pl-2">
                                <Form.Item
                                    label={
                                        <div className="font-semibold text-sm">
                                            {t('COOKIE.IconColor')}
                                        </div>
                                    }
                                    name={['iconColor']}
                                    rules={[
                                        {
                                            validator: checkColor,
                                        },
                                    ]}
                                >
                                    <InputColor />
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <div className="font-semibold text-sm">
                                            {t('COOKIE.BackgroundColor')}
                                        </div>
                                    }
                                    name={['iconBackground']}
                                    rules={[
                                        {
                                            validator: checkColor,
                                        },
                                    ]}
                                >
                                    <InputColor />
                                </Form.Item>
                            </div>
                            <div>
                                <div>{t('COOKIE.Preview')}</div>
                                <div className="bg-[#F2F2F2] rounded-md w-full px-4 py-2">
                                    <IconCookie
                                        color={iconBackground}
                                        bg={iconColor}
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="mt-2">
                            <Form.Item
                                label={
                                    <div className="text-sm">
                                        {t('COOKIE.UploadYourCompanyLogo')}
                                    </div>
                                }
                                rules={[
                                    {
                                        validator: checkLogo,
                                    },
                                ]}
                                name={['iconCookieId']}
                                valuePropName="fileList"
                                required={showLogo}
                            >
                                <ImgCrop
                                    beforeCrop={beforeUpload}
                                    showGrid
                                    rotationSlider
                                    aspectSlider
                                    showReset
                                >
                                    <Upload {...uploadProps}>
                                        {fileList.length < 1 && uploadButton}
                                    </Upload>
                                </ImgCrop>
                            </Form.Item>
                        </div>
                    )}
                </Collapse>
                {/* <Collapse icon={ICON[5]} title="ปิดกั้นคุกกี้ 3rd-Party">
                    <div className="flex justify-between items-center pt-2 mb-2">
                        <div className="text-sm">Auto Block 3rd-Party</div>
                        <Form.Item
                            noStyle
                            name={['autoblock3rdParty']}
                            valuePropName="checked"
                        >
                            <Switch
                                onChange={(checked) => setShowLogo(checked)}
                            />
                        </Form.Item>
                    </div>
                </Collapse> */}
            </div>
        </div>
    );
};

const uploadButton = (
    <div className="px-6">
        <svg
            width="41"
            height="32"
            viewBox="0 0 41 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5024 0C17.2425 0.00879434 14.0938 1.02029 11.6251 2.85175C9.73307 4.25425 8.36221 6.08175 8.00899 7.91562C3.86924 8.70187 0.742188 11.8044 0.742188 15.5507C0.742188 19.9028 4.96099 23.375 10.0813 23.375H19.2674V12.1274L13.9667 16.6898C13.7348 16.8893 13.4203 17.0013 13.0923 17.0013C12.7643 17.0013 12.4498 16.8893 12.2179 16.6898C11.986 16.4902 11.8557 16.2196 11.8557 15.9375C11.8557 15.6554 11.986 15.3848 12.2179 15.1852L19.628 8.81025C19.7427 8.7113 19.879 8.6328 20.029 8.57924C20.1791 8.52567 20.3399 8.4981 20.5024 8.4981C20.6648 8.4981 20.8257 8.52567 20.9757 8.57924C21.1257 8.6328 21.262 8.7113 21.3768 8.81025L28.7868 15.1852C29.0187 15.3848 29.149 15.6554 29.149 15.9375C29.149 16.2196 29.0187 16.4902 28.7868 16.6898C28.5549 16.8893 28.2404 17.0013 27.9124 17.0013C27.5845 17.0013 27.2699 16.8893 27.038 16.6898L21.7374 12.1274V23.375H32.0818C36.5625 23.375 40.2625 20.3363 40.2625 16.5176C40.2625 13.0411 37.1948 10.2085 33.2625 9.73038C32.6623 4.24788 27.1467 0 20.5024 0ZM19.2674 30.8125V23.375H21.7374V30.8125C21.7374 31.0943 21.6073 31.3645 21.3757 31.5638C21.144 31.7631 20.8299 31.875 20.5024 31.875C20.1748 31.875 19.8607 31.7631 19.6291 31.5638C19.3975 31.3645 19.2674 31.0943 19.2674 30.8125Z"
                fill="#C4C4C4"
            />
        </svg>
        <div className="text-[#4F4F4F] opacity-90 text-[10px] pt-4">
            Drop file here, paste or
            <span className="text-blue">browse file</span>
            <br />
            <br />
            Image only up to 2 MB. (Allowed file types: jpg ,svg or png)
        </div>
    </div>
);

export default Style;
